import React from 'react';
import { Image } from 'react-datocms';
import { Button, H1, TextLg } from 'atoms';
import { useDispatchUi } from 'context/ui';
import { useRouter } from 'next/router';
import LargeButton from '@/components/Views/Buttons';
import { MUZOLOGY_SIGNUP_URL } from '@/lib/defaults';

interface Props {
    heading?: string;
    subhead?: string;
    img: any;
    ctalink?: string;
    ctalabel?: string;
    videoLink?: any;
}

const Hero = ({
    heading,
    subhead,
    img,
    ctalink,
    ctalabel,
    videoLink
}: Props) => {
    const dispatch: any = useDispatchUi();
    const router = useRouter();
    return (
        <div id='parents-hero'>
            <div id='parents-hero-content'>
                <div id='parents-hero-left'>
                    <div style={{ width: '100%' }}>

                        <Image
                            lazyLoad={false}
                            data={{ ...img.responsiveImage }}
                            // Data={{ ...img.responsiveImage, bgColor: '#ffffff00' }}
                        />

                        {/*
              <img src={img.url} height={img.height} width={img.width}/>

            <Image
              src={img.url}
              height={img.height}
              width={img.width}
              priority={true}
              // loading="eager"
            />
            */}

                    </div>
                    <div id='button-container-mobile' className='button-group mt-4'>
                        <LargeButton
                            className='purple-button w-[220px]'
                            text='Sign Up My Child'
                            href={MUZOLOGY_SIGNUP_URL}
                            rightArrow={true}
                        />

                        <LargeButton
                            className='blue-button w-[220px]'
                            text='Sign Up As Educator'
                            href='/signup'
                            rightArrow={true}
                        />
                    </div>
                </div>
                <div id='parents-hero-right'>
                    <H1 pb={5}>{heading}</H1>
                    <TextLg textVariant='light'>{subhead}</TextLg>
                    <div id='button-container-non-mobile' className='button-group gap-4 mt-4'>
                        {/*
                        <LargeButton
                            className='pink-button mt-5 w-[200px]'
                            href={ctalink}
                            text={ctalabel}
                        />
                        */}
                        <LargeButton
                            className='purple-button w-[220px]'
                            text='Sign Up My Child'
                            href={MUZOLOGY_SIGNUP_URL}
                            rightArrow={true}
                        />

                        <LargeButton
                            className='blue-button w-[220px]'
                            text='Sign Up As Educator'
                            href='/signup'
                            rightArrow={true}
                        />
                        {/* <div
              id='watch-video'
              style={{
                width: '160px',
                transform: 'translate(24px, 12px)',
                cursor: 'pointer',
              }}
            >
              <img
                onClick={() =>
                  dispatch({
                    type: 'PLAY_VIDEO',
                    payload: videoLink,
                  })
                }
                style={{ width: '100%' }}
                src='/assets/graphics/watch-video.png'
              />
            </div> */}
                    </div>
                </div>
            </div>
            <style jsx>
                {`
                    #parents-hero {
                        font-family: 'Inter', sans-serif;
                        position: relative;
                        padding: 88px 60px 88px 60px;
                        background: linear-gradient(180deg, #f5f1f9 0%, #e7daf9 100%);
                    }

                    #parents-hero-content {
                        margin: 0 auto;
                        max-width: 1280px;
                        display: flex;
                        align-items: center;
                    }

                    #parents-hero-left {
                        width: 100%;
                        padding-right: 56px;
                    }

                    #parents-hero-right {
                        width: 100%;
                    }

                    @media (max-width: 992px) {
                        #parents-hero {
                            padding: 80px 40px 80px 40px;
                        }

                        #parents-hero-content {
                            flex-direction: column-reverse;
                        }

                        #parents-hero-left {
                            padding-right: 0px;
                        }

                        #parents-hero-right {
                            width: 100%;
                            padding: 48px 0px 16px 0px;
                        }

                        #watch-video {
                            display: none;
                        }
                    }

                    @media (max-width: 480px) {
                        #parents-hero {
                            padding: 80px 20px 48px 20px;
                        }

                        #button-container-non-mobile {
                            display: none;
                        }
                    }

                    @media (min-width: 480px) {
                        #button-container-mobile {
                            display: none;
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default Hero;
